<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-button :class="className" 
            size="default" type="primary" :disabled="disabled" 
            @click="ComputeResult" 
            :loading="loading">
            {{ displayName }}
        </el-button>
        <div class="hint"><i>{{ hint }}</i></div> 
    </el-col>
</template>

<script>
    import baseField from "../BaseField" 
    export default{
        name:"ButtonField",
        mixins:[baseField],
        computeResultFunction:{},
        data:{
            loading:false
        },
        created:function(){
            this.computeResultFunction = new Function("Context", "Content", "self", this.selfSetting.JavaScript);
        },
        methods:{
            ComputeResult:function(){
                this.loading = true;
                let context = this.buildFormContext();
                this.computeResultFunction(context, this.data, this);
            },
        }
    }
</script>